import { createSlice } from '@reduxjs/toolkit';

export interface OfficeContextState {
  host: Office.HostType;
  platform: Office.PlatformType;
  isOfficeWeb: boolean;
  isOfficeReady: boolean;
}

const initialState: OfficeContextState = {
  host: Office.HostType.Outlook,
  platform: Office.PlatformType.OfficeOnline,
  isOfficeWeb: false,
  isOfficeReady: false
};

const officeContextSlice = createSlice({
  name: 'officeContext',
  initialState,
  reducers: {
    updateOfficeContext(state, action) {
      return action.payload;
    },
    resetOfficeJSContext() {
      return initialState;
    }
  }
});

export const { updateOfficeContext, resetOfficeJSContext } = officeContextSlice.actions;
export default officeContextSlice.reducer;
